type CallToActions = {
  joined?: boolean
  productUrl: string
  purchased?: boolean
  freeSignUp?: boolean
  productHotLink?: string
  internalSalesPageUrl?: string | null
}

export const getProductCallToActions = ({
  purchased,
  freeSignUp,
  joined,
  productUrl,
  productHotLink,
  internalSalesPageUrl
}: CallToActions) => {
  if ((purchased || joined) && !freeSignUp) {
    return [
      {
        to: productUrl,
        label: 'home.card_cta.access',
        type: 'primary'
      }
    ]
  }

  if (freeSignUp && joined && !purchased && productHotLink) {
    return [
      {
        to: internalSalesPageUrl || productHotLink,
        label: 'home.card_cta.purchase',
        type: 'success'
      },
      {
        to: productUrl,
        label: 'home.card_cta.access_for_free',
        type: 'primary'
      }
    ]
  }

  if (freeSignUp && joined) {
    return [
      {
        to: productUrl,
        label: 'home.card_cta.access_for_free',
        type: 'primary'
      }
    ]
  }

  if (freeSignUp && !joined) {
    return [
      {
        to: productUrl,
        label: 'home.card_cta.try_free',
        type: 'success'
      }
    ]
  }

  return [
    {
      to: internalSalesPageUrl || productUrl,
      label: `home.card_cta.purchase`,
      type: 'success'
    }
  ]
}
